/* =========================================================
   CELEST • Mini-cart GLOBAL (integrado “full features”)
   - ✅ NO depende de #celest-mobile-pdp
   - ✅ Monta el DOM del mini-cart 1 sola vez en <body>
   - ✅ Hook icono bolsa header (bloquea el carrito del tema)
   - ✅ Hook add-to-cart en TODO el tema (AJAX) + abre mini-cart
   - ✅ Qty +/- + delete con loader inline (sin delays)
   - ✅ Descuento UI (+ aplicar / X quitar con spinner)
   - ✅ Envío gratis + ETA (incluye “Personalizado” si hay properties)
   - ✅ Pre-orden notice (solo móvil) + oculta envío si solo PO
   - ✅ Bridge event: document.dispatchEvent(new CustomEvent('celest:openMiniCart',{detail:{cart}}))
========================================================= */
(function(){
  if (window.CelestMiniCart && window.CelestMiniCart.__ready) return;

  const $  = (s, c=document)=>c.querySelector(s);
  const $$ = (s, c=document)=>Array.from(c.querySelectorAll(s));
  const mm = matchMedia('(max-width: 989px)');
  const onReady = fn => (document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded', fn, {once:true})
    : fn()
  );

  /* -------------------------
     CONFIG (desde theme o defaults)
     Puedes setear antes:
     window.CELEST_MINICART_CONFIG = { freeShippingThresholdCOP: 150000, deliveryMinDays: 3, ... }
  ------------------------- */
  const CFG = (()=>{
    const d = document.documentElement?.dataset || {};
    const w = window.CELEST_MINICART_CONFIG || {};
    const num = (v, def)=> {
      const n = parseFloat(String(v ?? '').replace(',','.'));
      return isFinite(n) ? n : def;
    };
    const int = (v, def)=> {
      const n = parseInt(String(v ?? ''), 10);
      return isFinite(n) ? n : def;
    };

    // Loader config (si ya lo usas en tu PDP, puedes pasarlo aquí también)
    return {
      freeShippingThresholdCOP: num(w.freeShippingThresholdCOP ?? d.freeShippingThreshold ?? 300000, 300000),
      deliveryMinDays: int(w.deliveryMinDays ?? d.deliveryMinDays ?? 3, 3),
      deliveryMaxDays: int(w.deliveryMaxDays ?? d.deliveryMaxDays ?? 7, 7),
      customDeliveryMinDays: int(w.customDeliveryMinDays ?? d.customDeliveryMinDays ?? 7, 7),
      customDeliveryMaxDays: int(w.customDeliveryMaxDays ?? d.customDeliveryMaxDays ?? 10, 10),

      // Loader behavior (compat con tu bloque)
      LOADER_MODE: String(w.loaderMode ?? d.loaderMode ?? 'spin').trim(),             // off | spin | morph | both | sketch
      SHOW_BTNS: String(w.loaderShowButtons ?? d.loaderShowButtons ?? 'true') === 'true',
      SHOW_OVERLAY: String(w.loaderShowOverlay ?? d.loaderShowOverlay ?? 'true') === 'true',
      BTN_SIZE: int(w.loaderBtnSize ?? d.loaderBtnSize ?? 40, 40),
      SPIN_MS: int(w.loaderSpeed ?? d.loaderSpeed ?? 900, 900),
      OVER_SIZE: int(w.loaderOverlaySize ?? d.loaderOverlaySize ?? 36, 36),
      OVER_ALPHA: int(w.loaderOverlayAlpha ?? d.loaderOverlayAlpha ?? 40, 40),
      MORPH_MS: int(w.morphSpeed ?? d.morphSpeed ?? 1200, 1200),
      MORPH_PATHS_RAW: String(w.morphPaths ?? d.morphPaths ?? '').trim(),
      SKETCH_IMG: String(w.sketchImg ?? d.sketchImg ?? ''),
      SKETCH_SIZE: int(w.sketchSize ?? d.sketchSize ?? (int(w.loaderBtnSize ?? d.loaderBtnSize ?? 18, 18)), 18),

      ICONS: {
  add: String(w.loaderAdd ?? d.loaderAdd ?? 'https://cdn.shopify.com/s/files/1/0901/7763/4599/files/logo_blanco_fondo_transparente_png.png?v=1757621901'),
  checkout: String(w.loaderCheckout ?? d.loaderCheckout ?? 'https://cdn.shopify.com/s/files/1/0901/7763/4599/files/logo_blanco_fondo_transparente_png.png?v=1757621901'),
  cart: String(w.loaderCart ?? d.loaderCart ?? '')
}

    };
  })();

  const fmtCOP0 = cents=>{
    try { return (cents/100).toLocaleString('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0,maximumFractionDigits:0}); }
    catch(_){ return '$ ' + Math.round(cents/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
  };

  /* -------------------------
     PREORDER helpers (global)
  ------------------------- */
  window.__celestIsPreorder = window.__celestIsPreorder || function(){
    // Global: intenta detectar en PDP si existe, si no -> false
    const r = document.getElementById('celest-mobile-pdp');
    if (!r) return false;
    const dsVal = (r.dataset?.preorder||'').toString().toLowerCase();
    if (dsVal === 'true' || dsVal === '1' || dsVal === 'yes') return true;
    try{
      const el = document.getElementById('ProductJson-celest-mobile-pdp');
      if (!el) return false;
      const p  = JSON.parse(el.textContent||'{}');
      const mf = p?.metafields?.custom?.preorder;
      const v  = (typeof mf==='object' && mf!==null) ? mf.value : mf;
      return String(v).toLowerCase()==='true';
    }catch(_){ return false; }
  };

  window.__celestAddLabel = window.__celestAddLabel || function(){
    return window.__celestIsPreorder() ? 'Pre-ordenar' : 'Añadir a la cesta';
  };

  /* -------------------------
     DOM mount (global)
  ------------------------- */
  function ensureMiniCartDOM(){
    let modal = $('.celestModal.celestPdp__cartModal');
    if(modal) return modal;

    modal = document.createElement('div');
    modal.className = 'celestModal celestPdp__cartModal';
    modal.hidden = true;

    modal.innerHTML = `
      <div class="celestPdp__cartBody" role="dialog" aria-modal="true" aria-label="Mini cart">
        <button class="celestPdp__cartClose" aria-label="Cerrar">×</button>
        <h3 class="celestPdp__cartTitle">Añadido a la bolsa (0)</h3>

        <!-- LISTA (zona scroll) -->
        <div class="celestPdp__cartItems js-cartItems"></div>

        <!-- SLOT APP + EMPTY STATE -->
        <div class="celestPdp__upsellSlot" hidden>
          <div class="celestPdp__emptyText">LA BOLSA ESTÁ VACÍA</div>
          <div class="essential-upsell-cross-sell-block"></div>
        </div>

        <div class="celestPdp__cartSubtotal">Subtotal <b class="js-subtotal"></b></div>

        <div class="celestPdp__shipBox">
          <div class="celestPdp__shipText js-shipText"></div>
          <div class="celestPdp__shipBarWrap">
            <div class="celestPdp__shipBar js-shipBar"></div>
          </div>
        </div>

        <div class="celestPdp__eta">
          <div class="celestPdp__shipText js-etaText"></div>
        </div>

        <div class="celestPdp__cartActions">
          <a class="celestPdp__continue" href="#" role="button">Seguir comprando</a>
          <a class="celestPdp__checkout" href="/checkout">Finalizar compra</a>
        </div>

        <div class="celestPdp__cartFooter"></div>
      </div>
    `;
    document.body.appendChild(modal);

    return modal;
  }

  /* -------------------------
     Loader Overlay (header icon)
  ------------------------- */
  function ensureOverlay(){
    let overlay = $('.celestLoaderOverlay');
    if(overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'celestLoaderOverlay';
    overlay.hidden = true;
    overlay.innerHTML = `<div class="celestLoaderOverlay__inner"></div>`;
    document.body.appendChild(overlay);
    return overlay;
  }

  /* -------------------------
     Loader builders (tu bloque)
  ------------------------- */
  function el(html){
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }
  function defaultMorphPaths(){
    return [
      'M40,10 C55,12 68,22 72,38 C76,53 71,68 58,76 C45,84 28,84 18,73 C8,62 6,43 14,28 C22,14 27,8 40,10 Z',
      'M38,8 C55,8 76,22 78,40 C80,58 63,77 44,79 C25,81 9,66 7,47 C5,28 21,8 38,8 Z',
      'M42,6 C60,10 78,26 78,44 C78,62 60,76 42,78 C24,80 8,70 6,52 C4,34 24,2 42,6 Z'
    ];
  }
  function resolveMorphPaths(){
    if(!CFG.MORPH_PATHS_RAW) return defaultMorphPaths();
    return CFG.MORPH_PATHS_RAW.split('\n').map(s=>s.trim()).filter(Boolean);
  }
  function buildSpin(imgUrl, size){
  if(imgUrl){
    return el(
      `<div class="celestLoader--btn" aria-hidden="true"
            style="position:absolute;inset:0;display:grid;place-items:center;pointer-events:none;">
         <img src="${imgUrl}" alt="" width="${size}" height="${size}"
              style="width:${size}px;height:${size}px;animation:celestBlink 900ms ease-in-out infinite;will-change:opacity;"/>
       </div>`
    );
  }
  return el(
    `<div class="celestLoader--btn" aria-hidden="true"
          style="position:absolute;inset:0;display:grid;place-items:center;pointer-events:none;">
       <svg viewBox="0 0 40 40" width="${size}" height="${size}"
            style="animation:celestSpin ${CFG.SPIN_MS}ms linear infinite">
         <circle cx="20" cy="20" r="16" fill="none" stroke="currentColor" stroke-width="4" opacity="0.2"></circle>
         <path d="M20 4 a16 16 0 0 1 0 32" fill="none" stroke="currentColor" stroke-width="4"></path>
       </svg>
     </div>`
  );
}


  function buildMorph(size, paths){
    const vals = paths.join(';');
    return el(
      `<div class="celestLoader--btn" aria-hidden="true" style="inset:0;display:grid;place-items:center;pointer-events:none;">
         <svg viewBox="0 0 84 84" width="${size}" height="${size}">
           <path fill="currentColor" opacity="0.95">
             <animate attributeName="d" dur="${CFG.MORPH_MS}ms" repeatCount="indefinite" values="${vals}" />
           </path>
         </svg>
       </div>`);
  }
  function buildBoth(size, paths){
    const node = buildMorph(size, paths);
    const svg  = node.querySelector('svg');
    if(svg) svg.style.animation = `celestSpin ${CFG.SPIN_MS}ms linear infinite`;
    return node;
  }
  function buildSketch(size, imgUrl){
    return el(
      `<div class="celestLoader--btn" aria-hidden="true" style="inset:0;display:grid;place-items:center;pointer-events:none;transform-origin:center;">
         <img src="${imgUrl}" alt="" width="${size}" height="${size}"
              style="width:${size}px;height:${size}px;animation:celestSketchIn 420ms ease-out both"/>
       </div>`);
  }
  function putLoaderInsideButton(btn, iconUrlForContext){
  if(!btn) return;
  btn.querySelectorAll('.celestLoader--btn').forEach(n => n.remove());
  let node;
  const paths = resolveMorphPaths();
  switch(CFG.LOADER_MODE){
    case 'off': return;
    case 'spin': node = buildSpin(iconUrlForContext, CFG.BTN_SIZE); break;
    case 'morph': node = buildMorph(CFG.BTN_SIZE, paths); break;
    case 'both': node = buildBoth(CFG.BTN_SIZE, paths); break;
    case 'sketch': node = buildSketch(CFG.SKETCH_SIZE, CFG.SKETCH_IMG || iconUrlForContext || CFG.ICONS.add || CFG.ICONS.checkout); break;
    default: node = buildSpin(iconUrlForContext, CFG.BTN_SIZE);
  }
  btn.classList.add('is-loading');

  // ✅ NUEVO: oculta texto y deja solo el logo
  btn.classList.add('celestHideBtnText');
  btn.setAttribute('aria-busy','true');

  btn.appendChild(node);

  const t = btn.querySelector('.js-addText');
  if(t) t.style.opacity = '0';
}
function clearButtonLoader(btn){
  if(!btn) return;
  btn.classList.remove('is-loading');
  btn.classList.remove('celestHideBtnText');
  btn.removeAttribute('aria-busy');
  btn.querySelectorAll('.celestLoader--btn').forEach(n => n.remove());
  const t = btn.querySelector('.js-addText');
  if(t) t.style.opacity = '';
}


  /* -------------------------
     Inline loader (qty/trash) (tu bloque)
  ------------------------- */
  function ensureInlineLoader(elm, sizePx){
    if(!elm) return null;
    const size = sizePx || 18;
    let wrap = elm.querySelector('.celestInlineLoaderWrap');
    if(!wrap){
      wrap = document.createElement('span');
      wrap.className = 'celestInlineLoaderWrap';
      wrap.style.display = 'none';
      wrap.innerHTML = `<span class="celestInlineLoader" aria-hidden="true" style="width:${size}px;height:${size}px;"></span>`;
      elm.appendChild(wrap);
    }
    return wrap;
  }
  function setInlineLoadingQty(box, on){
    if(!box) return;
    box.classList.toggle('is-loading', !!on);
    const wrap = ensureInlineLoader(box, 16);
    if(wrap) wrap.style.display = on ? 'grid' : 'none';
  }
  function setInlineLoadingBtn(btn, on){
    if(!btn) return;
    btn.classList.toggle('is-loading', !!on);
    const wrap = ensureInlineLoader(btn, 18);
    if(wrap) wrap.style.display = on ? 'grid' : 'none';
  }

  /* -------------------------
     Discount helpers (tu bloque, global)
  ------------------------- */
  let discUI = {
    wrap: null, toggleBtn: null, panel: null, input: null, applyBtn: null,
    closeLine: null, error: null, chip: null, chipX: null, _clearing: false
  };

  function celestGetCookie(name){
    try{
      const m = document.cookie.match(new RegExp('(^|;\\s*)' + name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,'\\$&') + '=([^;]*)'));
      return m ? decodeURIComponent(m[2]) : '';
    }catch(_){ return ''; }
  }
  function celestDeleteCookie(name){
    try{
      const host = location.hostname;
      const parts = host.split('.');
      const domains = [
        null, host, '.' + host, parts.length > 2 ? '.' + parts.slice(-2).join('.') : null
      ].filter(Boolean);

      document.cookie = `${name}=; Max-Age=0; path=/;`;
      domains.forEach(d=>{
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${d};`;
      });
    }catch(_){}
  }
  function celestClearDiscountPersist(){
    try{ localStorage.removeItem('celest_discount_code'); }catch(_){}
    try{
      ['discount_code','discount','discounts','shopify_discount','shopify_discounts','cart_discount','checkout_discount_code']
        .forEach(celestDeleteCookie);

      document.cookie.split(';').forEach(c=>{
        const n = (c.split('=')[0]||'').trim();
        if(n && n.toLowerCase().startsWith('discount')) celestDeleteCookie(n);
      });
    }catch(_){}
  }
  async function celestClearViaSoft(){
    try{
      await fetch(`/discount/clear?redirect=/cart&t=${Date.now()}`, {
        method: 'GET', credentials: 'same-origin', redirect: 'follow'
      });
    }catch(_){}
    try{
      await new Promise((resolve)=>{
        const ifr = document.createElement('iframe');
        ifr.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
        const url = `/discount/clear?redirect=/cart&t=${Date.now()}`;
        let doneCalled = false;
        const done = ()=>{ if(doneCalled) return; doneCalled = true; try{ ifr.remove(); }catch(_){} resolve(true); };
        ifr.onload = ()=> setTimeout(done, 180);
        ifr.src = url;
        document.body.appendChild(ifr);
        setTimeout(done, 1200);
      });
    }catch(_){}
  }
  function celestClearViaHardNavigate(){
    try{
      const returnTo = location.pathname + location.search + location.hash;
      sessionStorage.setItem('celest_after_clear_discount_open_cart', '1');
      location.href = `/discount/clear?redirect=${encodeURIComponent(returnTo)}`;
    }catch(_){
      location.href = `/discount/clear?redirect=/cart`;
    }
  }

  /* -------------------------
     Mini-cart core
  ------------------------- */
  const api = window.CelestMiniCart = window.CelestMiniCart || {};
  api.__ready = true;

  let rootModal, cartBodyEl, cartTitleEl, cartItems, upsellSlot, subtotalEl, shipTextEl, shipBarEl;
  let etaTextEl, closeCartBtn, continueBtn, checkoutBtn;

  function cacheNodes(){
    rootModal   = ensureMiniCartDOM();
    cartBodyEl  = $('.celestPdp__cartBody', rootModal);
    cartTitleEl = $('.celestPdp__cartTitle', rootModal);
    cartItems   = $('.js-cartItems', rootModal);
    upsellSlot  = $('.celestPdp__upsellSlot', rootModal);
    subtotalEl  = $('.js-subtotal', rootModal);
    shipTextEl  = $('.js-shipText', rootModal);
    shipBarEl   = $('.js-shipBar', rootModal);

    etaTextEl   = $('.js-etaText', rootModal);
    if(!etaTextEl){
      // safety
      etaTextEl = document.createElement('div');
      etaTextEl.className = 'celestPdp__shipText js-etaText';
      $('.celestPdp__eta', rootModal)?.appendChild(etaTextEl);
    }

    closeCartBtn = $('.celestPdp__cartClose', rootModal);
    continueBtn  = $('.celestPdp__continue', rootModal);
    checkoutBtn  = $('.celestPdp__checkout', rootModal);

        // ✅ Marker: este mini-cart lo controla el GLOBAL
    try{
      rootModal?.setAttribute('data-celest-minicart', 'global');
      cartBodyEl?.classList.add('celestMiniCart--global');
    }catch(_){}


    // alinear como lo tenías
    if(shipTextEl) shipTextEl.style.textAlign = 'center';
    if(etaTextEl && etaTextEl.parentElement && etaTextEl.parentElement.style){
      etaTextEl.parentElement.style.justifyContent = 'center';
    }
  }

function setMiniCartTopUnderHeader(){
  if (!cartBodyEl) return;

  const header =
    document.getElementById('celest-header') ||
    document.querySelector('#shopify-section-header header') ||
    document.querySelector('header');

  const hh = header ? Math.ceil(header.getBoundingClientRect().height) : 0;

  // ✅ Esta variable la usa el CSS (arriba)
  document.documentElement.style.setProperty('--celestHeaderH', hh + 'px');

  // ✅ Mobile: sigue como lo tienes (full width + height calculada)
  if (mm.matches){
    const vv = window.visualViewport;
    const vvh = vv ? Math.ceil(vv.height) : window.innerHeight;

    cartBodyEl.style.position = 'fixed';
    cartBodyEl.style.left = '0';
    cartBodyEl.style.right = '0';
    cartBodyEl.style.bottom = '0';
    cartBodyEl.style.top = `calc(${hh}px + env(safe-area-inset-top, 0px))`;
    cartBodyEl.style.height = `calc(${vvh}px - ${hh}px - env(safe-area-inset-bottom, 0px))`;
    cartBodyEl.style.maxHeight = 'none';
    return;
  }

  // ✅ Desktop: NO pongas top/height/width inline -> lo controla el CSS FIX FINAL
  cartBodyEl.style.position = '';
  cartBodyEl.style.top = '';
  cartBodyEl.style.bottom = '';
  cartBodyEl.style.left = '';
  cartBodyEl.style.right = '';
  cartBodyEl.style.height = '';
  cartBodyEl.style.maxHeight = '';
  cartBodyEl.style.width = '';
}


  function openCart(){
  if (!rootModal || !cartBodyEl) return;

  rootModal.hidden = false;
  document.body.classList.add('celestCart-open');
  setMiniCartTopUnderHeader();

  if (mm.matches){
    // reset estados
    cartBodyEl.classList.remove('is-closing');
    // fuerza estado cerrado antes de abrir para que SIEMPRE haya transición
    cartBodyEl.classList.remove('is-open');
    void cartBodyEl.offsetHeight; // reflow

    requestAnimationFrame(()=>{
      cartBodyEl.classList.add('is-open');
    });

    document.body.style.overflow = 'hidden';
    return;
  }

  requestAnimationFrame(()=>cartBodyEl.classList.add('is-open'));
}


function closeCartFn(){
  if (!rootModal || !cartBodyEl) return;
  if (cartBodyEl.dataset.closing === '1') return;
  cartBodyEl.dataset.closing = '1';

  if (mm.matches){
    cartBodyEl.classList.remove('is-open');
    cartBodyEl.classList.add('is-closing');

    const done = ()=>{
      rootModal.hidden = true;
      cartBodyEl.classList.remove('is-closing');
      cartBodyEl.dataset.closing = '';
      document.body.classList.remove('celestCart-open');
      document.body.style.overflow = '';
    };

    const onEnd = (e)=>{
      if (e.propertyName === 'transform') done();
    };

    cartBodyEl.addEventListener('transitionend', onEnd, { once:true });
    setTimeout(done, 520); // backup
    return;
  }

  cartBodyEl.classList.remove('is-open');
  cartBodyEl.addEventListener('transitionend', ()=>{
    rootModal.hidden = true;
    document.body.classList.remove('celestCart-open');
    cartBodyEl.dataset.closing = '';
  }, { once:true });

  document.body.style.overflow = '';
}

  /* -------------------------
     Layout helpers (tu bloque, global)
  ------------------------- */
  function ensureEmptyText(){
    let emptyTextEl = $('.celestPdp__emptyText', rootModal);
    if (!emptyTextEl && cartItems){
      emptyTextEl = document.createElement('div');
      emptyTextEl.className = 'celestPdp__emptyText';
      emptyTextEl.textContent = 'LA BOLSA ESTÁ VACÍA';
      emptyTextEl.style.display = 'none';
      cartItems.insertBefore(emptyTextEl, cartItems.firstChild || null);
    }
    return emptyTextEl;
  }

  function prepareCartLayout(){
    if (!cartBodyEl) return;

    if (cartBodyEl.dataset.stickyReady !== '1'){
      cartBodyEl.dataset.stickyReady = '1';

      Object.assign(cartBodyEl.style, {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%'
      });

      if (!mm.matches){
  // ❌ NO fuerces top fijo en desktop, lo controla setMiniCartTopUnderHeader()
  // cartBodyEl.style.top = cartBodyEl.style.top || '76px';
  cartBodyEl.style.borderRadius = cartBodyEl.style.borderRadius || '12px';
}


      if (cartItems){
        cartItems.classList.add('is-scrollArea');
        Object.assign(cartItems.style, {
          flex: '1 1 auto',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'contain',
          margin: '0 0 6px',
          paddingTop: '0'
        });
      }

      // upsell dentro del scroll
      if (upsellSlot && cartItems && upsellSlot.parentNode !== cartItems){
        cartItems.appendChild(upsellSlot);
      }

      if (upsellSlot){
        upsellSlot.style.marginTop = '0';
        upsellSlot.style.paddingTop = '0';
        const m = upsellSlot.querySelector('.celestPdp__upsellMount, .essential-upsell-cross-sell-block');
        if (m){
          m.style.marginTop = '0';
          m.style.paddingTop = '0';
        }
      }

      // footer sticky: shipBox + subtotal + actions + discount (lo reubicamos luego)
      let footer = $('.celestPdp__cartFooter', rootModal);
      if (!footer){
        footer = document.createElement('div');
        footer.className = 'celestPdp__cartFooter';
        cartBodyEl.appendChild(footer);
        Object.assign(footer.style, { position:'sticky', bottom:'0', background:'#fff' });
      }

      const shipBox  = $('.celestPdp__shipBox', rootModal);
      const subtotal = $('.celestPdp__cartSubtotal', rootModal);
      const actions  = $('.celestPdp__cartActions', rootModal);
      [shipBox, subtotal, actions].forEach(n => { if(n && n.parentNode !== footer) footer.appendChild(n); });

      if (shipBox){ shipBox.style.margin = '4px 0 8px'; }
      if (subtotal){ subtotal.style.padding = '6px 0'; }
      if (shipTextEl) shipTextEl.style.textAlign = 'center';

      const etaWrap = $('.celestPdp__eta', rootModal);
      if (etaWrap){
        etaWrap.style.display = 'flex';
        etaWrap.style.justifyContent = 'center';
        etaWrap.style.textAlign = 'center';
        etaWrap.style.marginTop = '6px';
      }
    }

    function adjustCartLayout(){
      if (!cartItems) return;

      const count = cartItems.querySelectorAll('.celestPdp__cartItem').length;
      const footer = $('.celestPdp__cartFooter', rootModal);
      const fh = footer ? Math.ceil(footer.getBoundingClientRect().height) : 0;
      cartItems.style.paddingBottom = (fh ? (fh + 12) : 16) + 'px';

      const upsellMount = $('.celestPdp__upsellMount', rootModal);
      const upsellActive = (() => {
        if (!upsellMount) return false;
        const essential = upsellMount.querySelector('.essential-upsell-cross-sell-block');
        if (!essential) return false;
        const hasNodes = essential.children && essential.children.length > 0;
        const hasHtml  = (essential.innerHTML || '').replace(/\s+/g,'').length > 0;
        const h = essential.getBoundingClientRect ? essential.getBoundingClientRect().height : 0;
        return !!(hasNodes || hasHtml || h > 40);
      })();

      if (count === 0){
        cartItems.style.flex      = '1 1 auto';
        cartItems.style.maxHeight = '';
        cartItems.style.minHeight = mm.matches ? '52vh' : '360px';
      }
      else if (count === 1) {
        cartItems.style.flex      = '1 1 auto';
        cartItems.style.maxHeight = '';

        const hasDiscount = !!cartItems.querySelector('.celestCartPrice--old, .celestCartTag--discount, .celestCart__discountInfo');

        if (upsellActive) {
          if (hasDiscount) cartItems.style.minHeight = mm.matches ? '80vh' : '550px';
          else             cartItems.style.minHeight = mm.matches ? '90vh' : '650px';
        } else {
          cartItems.style.minHeight = mm.matches ? '60vh' : '420px';
        }
      }
      else if (count === 2){
        cartItems.style.flex      = '1 1 auto';
        cartItems.style.maxHeight = mm.matches ? '56vh' : '44vh';
        cartItems.style.minHeight = '300px';
      }
      else{
        cartItems.style.flex      = '1 1 auto';
        cartItems.style.maxHeight = mm.matches ? '66vh' : '60vh';
        cartItems.style.minHeight = '360px';
      }
    }

    adjustCartLayout();

    if (!cartBodyEl._celestCartMO && cartItems){
      const mo = new MutationObserver(adjustCartLayout);
      mo.observe(cartItems, { childList:true });
      cartBodyEl._celestCartMO = mo;

      const mo2 = new MutationObserver(adjustCartLayout);
      const footer = $('.celestPdp__cartFooter', rootModal);
      if (footer) mo2.observe(footer, { childList:true, subtree:true });
      cartBodyEl._celestCartFooterMO = mo2;
    }

    window.addEventListener('resize', adjustCartLayout, { passive:true });
  }

  /* -------------------------
     Discount UI (montaje + render) (tu bloque)
  ------------------------- */
  function ensureDiscountUI(){
    // ✅ Si ya tenemos refs y ya está bindeado, no repetir
    if (discUI.wrap && discUI.wrap.dataset.bound === '1') return;

    let footer = $('.celestPdp__cartFooter', rootModal);
    if (!footer && cartBodyEl) {
      footer = document.createElement('div');
      footer.className = 'celestPdp__cartFooter';
      cartBodyEl.appendChild(footer);
    }

    // ✅ 1) Reusar si ya existe (PDP o render previo) + eliminar duplicados
    const existing = rootModal ? Array.from(rootModal.querySelectorAll('.celestPdp__discountWrap')) : [];
    if (existing.length){
      discUI.wrap = existing[0];

      // borra extras (esto mata el “Añadir descuento” duplicado)
      existing.slice(1).forEach(n => { try{ n.remove(); }catch(_){ } });

      discUI.wrap.setAttribute('data-celest-owner','global');

      // ✅ Si por alguna razón el HTML no es el esperado, lo normalizamos
      const hasToggle = !!discUI.wrap.querySelector('.celestPdp__discToggle');
      const hasPanel  = !!discUI.wrap.querySelector('.celestPdp__discPanel');
      const hasChip   = !!discUI.wrap.querySelector('.celestPdp__discChip');

      if (!hasToggle || !hasPanel || !hasChip){
        discUI.wrap.innerHTML = `
          <button type="button" class="celestPdp__discToggle" aria-expanded="false">
            <span class="celestPdp__discIcon" aria-hidden="true">+</span>
            <span class="celestPdp__discToggleText">Añadir descuento</span>
          </button>

          <div class="celestPdp__discPanel" aria-hidden="true">
            <div class="celestPdp__discCloseLine" role="button" tabindex="0">
              <span class="celestPdp__discIcon" aria-hidden="true">×</span>
              <span class="celestPdp__discToggleText">Cerrar</span>
            </div>

            <div class="celestPdp__discRow">
              <input class="celestPdp__discInput" type="text" inputmode="text" autocomplete="off"
                     placeholder="Código de descuento" />
              <button type="button" class="celestPdp__discApply">APLICAR</button>
            </div>

            <div class="celestPdp__discError"></div>
          </div>

          <div class="celestPdp__discChip" hidden>
            <span class="celestPdp__discChipText"></span>
            <button type="button" class="js-clearDiscount" aria-label="Quitar cupón">
              <span class="celestDiscChipX__x" aria-hidden="true">×</span>
              <span class="celestDiscChipX__spinner" aria-hidden="true"></span>
            </button>
          </div>
        `;
      }
    } else {
      // ✅ 2) Si no existe, lo creamos una sola vez
      discUI.wrap = document.createElement('div');
      discUI.wrap.className = 'celestPdp__discountWrap';
      discUI.wrap.setAttribute('data-celest-owner','global');

      discUI.wrap.innerHTML = `
        <button type="button" class="celestPdp__discToggle" aria-expanded="false">
          <span class="celestPdp__discIcon" aria-hidden="true">+</span>
          <span class="celestPdp__discToggleText">Añadir descuento</span>
        </button>

        <div class="celestPdp__discPanel" aria-hidden="true">
          <div class="celestPdp__discCloseLine" role="button" tabindex="0">
            <span class="celestPdp__discIcon" aria-hidden="true">×</span>
            <span class="celestPdp__discToggleText">Cerrar</span>
          </div>

          <div class="celestPdp__discRow">
            <input class="celestPdp__discInput" type="text" inputmode="text" autocomplete="off"
                   placeholder="Código de descuento" />
            <button type="button" class="celestPdp__discApply">APLICAR</button>
          </div>

          <div class="celestPdp__discError"></div>
        </div>

        <div class="celestPdp__discChip" hidden>
          <span class="celestPdp__discChipText"></span>
          <button type="button" class="js-clearDiscount" aria-label="Quitar cupón">
            <span class="celestDiscChipX__x" aria-hidden="true">×</span>
            <span class="celestDiscChipX__spinner" aria-hidden="true"></span>
          </button>
        </div>
      `;

      const subtotalRow = $('.celestPdp__cartSubtotal', rootModal);
      if (subtotalRow && subtotalRow.parentNode) {
        subtotalRow.parentNode.insertBefore(discUI.wrap, subtotalRow);
      } else {
        footer.appendChild(discUI.wrap);
      }
    }

    // ✅ cache refs SIEMPRE sobre la wrap final
    discUI.toggleBtn = discUI.wrap.querySelector('.celestPdp__discToggle');
    discUI.panel     = discUI.wrap.querySelector('.celestPdp__discPanel');
    discUI.input     = discUI.wrap.querySelector('.celestPdp__discInput');
    discUI.applyBtn  = discUI.wrap.querySelector('.celestPdp__discApply');
    discUI.closeLine = discUI.wrap.querySelector('.celestPdp__discCloseLine');
    discUI.error     = discUI.wrap.querySelector('.celestPdp__discError');
    discUI.chip      = discUI.wrap.querySelector('.celestPdp__discChip');
    discUI.chipX     = discUI.wrap.querySelector('button.js-clearDiscount');

    // ✅ Evitar doble bind
    if (discUI.wrap.dataset.bound === '1') return;
    discUI.wrap.dataset.bound = '1';

    function setChipXLoading(on){
      if(!discUI.chipX) return;
      discUI.chipX.classList.toggle('is-loading', !!on);
      discUI.chipX.disabled = !!on;
      discUI.chipX.setAttribute('aria-disabled', on ? 'true' : 'false');
    }
    discUI._setChipXLoading = setChipXLoading;

    function setOpen(open){
      if (!discUI.panel || !discUI.toggleBtn) return;

      discUI.panel.classList.toggle('is-open', !!open);
      discUI.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      discUI.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      discUI.toggleBtn.hidden = !!open;

      const icon = discUI.toggleBtn.querySelector('.celestPdp__discIcon');
      const txt  = discUI.toggleBtn.querySelector('.celestPdp__discToggleText');
      if (icon) icon.textContent = '+';
      if (txt)  txt.textContent  = 'Añadir descuento';
    }

    function setError(msg){
      if (!discUI.error) return;
      if (!msg){
        discUI.error.classList.remove('is-show');
        discUI.error.textContent = '';
        return;
      }
      discUI.error.textContent = msg;
      discUI.error.classList.add('is-show');
    }

    async function fetchCart(){
      return fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin' }).then(r=>r.json());
    }

    function getDiscountApplications(cart){
      return cart?.cart_level_discount_applications || cart?.discount_applications || [];
    }

    function findAppliedCode(cart){
      const apps = getDiscountApplications(cart);
      if (!apps || !apps.length) return null;
      const codeApp = apps.find(a => (a.type||'').toLowerCase() === 'discount_code');
      if (codeApp && codeApp.title) return codeApp.title;
      return apps[0]?.title || null;
    }

    async function applyDiscount(code){
      code = String(code||'').trim();
      if (!code) return;

      setError('');
      discUI.applyBtn.disabled = true;

      try{
        await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
          method:'GET',
          credentials:'same-origin'
        });

        const cart = await fetchCart();
        const applied = findAppliedCode(cart);

        if (!applied){
          if (discUI.input){
            discUI.input.classList.remove('is-shake');
            void discUI.input.offsetWidth;
            discUI.input.classList.add('is-shake');
          }
          try{ if('vibrate' in navigator) navigator.vibrate([60,40,60]); }catch(_){}
          setError('Código promocional incluido no válido. Puede que esté caducado, no sea compatible con otros descuentos o esté mal escrito.');
          discUI.applyBtn.disabled = false;
          return;
        }

        setOpen(false);
        discUI.input.value = '';
        setError('');

        renderMiniCart(cart);
        openCart();

      }catch(e){
        console.warn('Discount apply error', e);
        setError('No pudimos aplicar el código en este momento. Inténtalo de nuevo.');
      }finally{
        discUI.applyBtn.disabled = false;
      }
    }

    async function clearDiscount(){
      if (discUI._clearing) return;
      discUI._clearing = true;

      discUI._setChipXLoading && discUI._setChipXLoading(true);

      try{
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });

        if (typeof celestClearDiscountPersist === 'function') celestClearDiscountPersist();
        await celestClearViaSoft();

        const refreshedCart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());

        renderMiniCart(refreshedCart);
        openCart();

        if (discUI.chip) discUI.chip.hidden = true;
        if (discUI.toggleBtn) discUI.toggleBtn.hidden = false;

      }catch(err){
        console.error('Error clearing discount:', err);
      }finally{
        discUI._setChipXLoading && discUI._setChipXLoading(false);
        discUI._clearing = false;
      }
    }

    discUI.toggleBtn?.addEventListener('click', ()=>{
      const open = discUI.panel.classList.contains('is-open');
      setOpen(!open);
      if (!open) setTimeout(()=>discUI.input?.focus?.(), 50);
      else setError('');
    });

    discUI.closeLine?.addEventListener('click', ()=>{ setOpen(false); setError(''); });
    discUI.closeLine?.addEventListener('keydown', (e)=>{ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); setOpen(false); setError(''); } });

    discUI.applyBtn?.addEventListener('click', ()=> applyDiscount(discUI.input?.value));
    discUI.input?.addEventListener('keydown', (e)=>{
      if (e.key === 'Enter'){
        e.preventDefault();
        applyDiscount(discUI.input.value);
      }
    });

    discUI.chipX?.addEventListener('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      clearDiscount();
    });

    discUI._setOpen = setOpen;
    discUI._setError = setError;
    discUI._findAppliedCode = findAppliedCode;
  }


  function renderDiscountUIFromCart(cart){
    ensureDiscountUI();
    if (!discUI.wrap) return;

    const code = discUI._findAppliedCode ? discUI._findAppliedCode(cart) : null;

    if (code){
      const chipText = discUI.chip.querySelector('.celestPdp__discChipText');
      if (chipText) chipText.textContent = String(code).toUpperCase();

      discUI.chip.hidden = false;
      discUI.toggleBtn.hidden = true;
      discUI.panel.classList.remove('is-open');
      discUI.panel.setAttribute('aria-hidden','true');
      discUI.toggleBtn.setAttribute('aria-expanded','false');
      discUI._setError && discUI._setError('');
    } else {
      discUI.chip.hidden = true;
      discUI.toggleBtn.hidden = false;
      discUI._setOpen && discUI._setOpen(false);
    }

    // mantener discount pegado al subtotal dentro del footer
    const footer = $('.celestPdp__cartFooter', rootModal);
    const subtotal = $('.celestPdp__cartSubtotal', rootModal);
    if (discUI.wrap && footer){
      if (discUI.wrap.parentNode !== footer){
        if (subtotal && subtotal.parentNode === footer) footer.insertBefore(discUI.wrap, subtotal);
        else footer.insertBefore(discUI.wrap, footer.firstChild || null);
      }
    }
  }

  /* -------------------------
     Shipping + ETA (tu lógica)
  ------------------------- */
  function updateShipping(subtotalCents, cart){
    const threshold = Math.round(parseFloat(CFG.freeShippingThresholdCOP || 150000) * 100);

    if(shipTextEl && shipBarEl){
      if(subtotalCents >= threshold){
        shipTextEl.textContent = 'Tu pedido cumple los requisitos de envío gratuito.';
        shipBarEl.style.width='100%';
      }else{
        const miss = threshold - subtotalCents;
        shipTextEl.textContent = `Te faltan ${fmtCOP0(miss)} para envío gratuito.`;
        shipBarEl.style.width = Math.max(2, Math.min(100, (subtotalCents/threshold)*100)) + '%';
      }
    }

    const minD = parseInt(CFG.deliveryMinDays || 3, 10);
    const maxD = parseInt(CFG.deliveryMaxDays || 7, 10);
    const cMin = parseInt(CFG.customDeliveryMinDays || 7, 10);
    const cMax = parseInt(CFG.customDeliveryMaxDays || 10, 10);

    const hasCustom = !!(cart?.items || []).some(it => {
      const props = it.properties || {};
      return Object.keys(props).some(k => {
        const key = String(k || '');
        const val = props[k];
        if (key.startsWith('_')) return false;
        return val !== null && val !== undefined && String(val).trim() !== '';
      });
    });

    if (!etaTextEl) return;

    let etaMsg = `🚚 Entrega estimada: <b>${minD}–${maxD} días hábiles</b> (Colombia)`;
    if(hasCustom){
      etaMsg += ` — Los productos personalizados tienen una entrega estimada de <b>${cMin}–${cMax} días hábiles</b>.`;
    }
    etaTextEl.innerHTML = etaMsg;
  }

  /* -------------------------
     Sync contador del tema (Prestige y comunes)
  ------------------------- */
  function syncThemeCount(cart){
    try{
      const count = cart?.item_count || 0;
      const selectors = [
        '[data-cart-count]','[data-cart-count-bubble]','.Header__CartCount',
        '.header__cart-count','.cart-count-bubble','.header__icon-bubble',
        '.site-header__cart-count','.js-cart-count'
      ];
      $$(selectors.join(',')).forEach(el=>{
        el.textContent = count;
        if(el.tagName==='SUP' || (el.className||'').includes('bubble')){
          el.style.display = count>0 ? '' : 'none';
        }
        if(el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', count>0 ? 'false':'true');
      });

      const detail = {cart};
      ['cart:refresh','cart:updated','prestige:cart:refresh','cart-drawer:refresh']
        .forEach(evt=>document.dispatchEvent(new CustomEvent(evt,{detail})));
    }catch(err){ console.warn('Sync theme failed', err); }
  }

  /* -------------------------
     Qty / Delete bind (tu bloque)
  ------------------------- */
  function bindDeleteMini(container){
    if(!container) return;

    container.querySelectorAll('.celestPdp__deleteItem').forEach(btn=>{
      if(btn.__celestBound) return;
      btn.__celestBound = true;

      const key = btn.getAttribute('data-key');
      if(!key) return;

      btn.addEventListener('click', async (e)=>{
        e.preventDefault();
        e.stopPropagation();

        if(btn.classList.contains('is-loading')) return;
        setInlineLoadingBtn(btn, true);

        try{
          await fetch('/cart/change.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        }catch(err){
          console.warn('Delete error', err);
        }finally{
          try{
            const newCart = await fetch('/cart.js', { headers:{'Accept':'application/json'} }).then(r=>r.json());
            renderMiniCart(newCart);
          }catch(_){}
          setInlineLoadingBtn(btn, false);
        }
      });
    });
  }

  function bindQtyMini(container){
    if (!container) return;

    container.querySelectorAll('.celestPdp__qtyMini').forEach(box=>{
      const key  = box.getAttribute('data-key');
      const line = parseInt(box.getAttribute('data-line')||'0',10);
      const vid  = box.getAttribute('data-vid');
      if (!key) return;

      const minus = box.querySelector('.qMinus');
      const plus  = box.querySelector('.qPlus');
      const valEl = box.querySelector('.qVal');

      const setLoading = (on)=>{
        box.dataset.loading = on ? '1' : '';
        if(minus) minus.disabled = !!on;
        if(plus)  plus.disabled  = !!on;
        setInlineLoadingQty(box, !!on);
      };

      async function softFetch(url, body){
        return fetch(url, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify(body)
        });
      }

      async function refreshCart(){
        const rc = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
        const newCart = await rc.json();
        renderMiniCart(newCart);
      }

      async function updateQty(newQty){
        setLoading(true);
        try{
          let r = await softFetch('/cart/change.js', { id: key, quantity: newQty });
          if (!r.ok && line){
            r = await softFetch('/cart/change.js', { line: line, quantity: newQty });
          }
          if (!r.ok && newQty < 1 && vid){
            await softFetch('/cart/update.js', { updates: { [vid]: 0 } });
          }
        }catch(e){
          console.warn('Qty change error', e);
        }finally{
          await refreshCart();
          setLoading(false);
        }
      }

      if(box.__celestQtyBound) return;
      box.__celestQtyBound = true;

      minus?.addEventListener('click', ()=>{
        if(box.dataset.loading === '1') return;
        const q = parseInt(valEl.textContent || '1', 10);
        updateQty(q - 1);
      });

      plus?.addEventListener('click', ()=>{
        if(box.dataset.loading === '1') return;
        const q = parseInt(valEl.textContent || '1', 10);
        updateQty(q + 1);
      });
    });
  }

  /* -------------------------
     Render mini-cart (TU lógica principal, adaptada global)
  ------------------------- */
  function renderMiniCart(cart){
    if (!cart || !cartItems) return;

    const items = cart.items || [];
    const hasPO = items.some(it => (it.properties||{})._is_preorder === '1');

    const cartLevelApps =
      cart.cart_level_discount_applications ||
      cart.discount_applications ||
      [];
    const hasCartLevelDiscount = cartLevelApps.length > 0;

    const anyLineHasDiscount = items.some(li =>
      (li.line_level_discount_allocations && li.line_level_discount_allocations.length) ||
      (li.discount_allocations && li.discount_allocations.length)
    );

    let globalDiscPct   = 0;
    let globalDiscTitle = null;

    if (hasCartLevelDiscount && cart.items_subtotal_price > 0) {
      const diff = Math.max(0, (cart.items_subtotal_price - cart.total_price));
      if (diff > 0) {
        globalDiscPct   = Math.round(diff * 100 / cart.items_subtotal_price);
        globalDiscTitle = (cartLevelApps[0] && cartLevelApps[0].title) || null;
      }
    }

    const shouldApplyGlobalPerLine = globalDiscPct > 0 && !anyLineHasDiscount;
    const hasOnlyPO = hasPO && items.every(it => (it.properties||{})._is_preorder === '1');

    if (cartTitleEl) cartTitleEl.textContent = `Añadido a la bolsa (${cart.item_count || 0})`;

    ensureDiscountUI();
    prepareCartLayout();

    // Pre-orden notice (solo móvil)
    let poNotice = $('.celestPdp__poNotice', rootModal);
    if (!poNotice){
      poNotice = document.createElement('div');
      poNotice.className = 'celestPdp__poNotice';
      poNotice.style.cssText = 'margin:10px 0 8px;padding:12px 14px;border-radius:12px;background:#fff3cd;color:#7a5c00;font-weight:600;';
      poNotice.hidden = true;
      cartBodyEl.insertBefore(poNotice, cartItems);
    }
    const showOnMobile = mm.matches && hasPO;
    if (showOnMobile){
      poNotice.innerHTML = 'Tienes artículos de <b>Pre-orden</b> en tu carrito que solo serán enviados el día de su lanzamiento.';
      poNotice.hidden = false;
    } else {
      poNotice.hidden = true;
    }

    if (!poNotice.dataset.boundResize){
      poNotice.dataset.boundResize = '1';
      window.addEventListener('resize', ()=>{
        const onlyMobile = matchMedia('(max-width: 989px)').matches && hasPO;
        poNotice.hidden = !onlyMobile;
      }, {passive:true});
    }

    // Ocultar envío/ETA si solo PO
    const shipBoxEl = $('.celestPdp__shipBox', rootModal);
    const etaWrapEl = $('.celestPdp__eta', rootModal)?.parentElement || $('.celestPdp__eta', rootModal);
    if (hasOnlyPO){
      if (shipBoxEl) shipBoxEl.style.display = 'none';
      if (etaWrapEl) etaWrapEl.style.display = 'none';
    } else {
      if (shipBoxEl) shipBoxEl.style.display = '';
      if (etaWrapEl) etaWrapEl.style.display = '';
    }

    // preservar empty text y upsell antes de limpiar
    const emptyTextEl = ensureEmptyText();
    if (upsellSlot && upsellSlot.parentNode) upsellSlot.parentNode.removeChild(upsellSlot);
    if (emptyTextEl && emptyTextEl.parentNode) emptyTextEl.parentNode.removeChild(emptyTextEl);

    cartItems.innerHTML = '';
    if (emptyTextEl) cartItems.insertBefore(emptyTextEl, cartItems.firstChild || null);

    // render items
    items.forEach((it, idx)=>{
      const props = it.properties || {};
      const isPO  = props._is_preorder === '1';

      const isGiftFlag =
        props._is_gift === '1' ||
        String(props['Gratis'] || '').toLowerCase() === 'true' ||
        String(props['Gratis'] || '').toLowerCase() === 'sí';

      const anyText = v => v !== undefined && v !== null && String(v).trim() !== '';
const keys = Object.keys(props || {});
const keysLC = keys.map(k => String(k).toLowerCase());

/* ---------------------------------------------------------
   1) “Es personalizable” (potencial) -> NO mostrar etiqueta
--------------------------------------------------------- */
const isPersonalizableProduct =
  props._is_personalizable === '1' ||
  props._personalizable === '1' ||
  props._pz_base === '1' ||
  keysLC.some(k => k.includes('personalizable')) ||
  keysLC.some(k => k.includes('personaliz') && String(props[k]||'') === '1');

/* ---------------------------------------------------------
   2) “Personalización aplicada” (real) -> SÍ mostrar etiqueta
   - Solo se activa si hay datos concretos (letras / iniciales /
     monograma / color personalización / puntos / config / resumen)
   - Evita falsos positivos por “Color” genérico de variante
--------------------------------------------------------- */
const hasPZData =
  anyText(props['_pz_letters']) ||
  anyText(props['_pz_color']) ||
  anyText(props['_pz_config']) ||
  anyText(props['_pz_summary']) ||
  anyText(props['_pz_price_text']) ||
  anyText(props['Letras']) ||
  anyText(props['Iniciales']) ||
  anyText(props['Monograma']) ||
  anyText(props['Personalización']) ||
  anyText(props['Personalizado']) ||
  (props['Puntos'] !== undefined && props['Puntos'] !== null && String(props['Puntos']).trim() !== '') ||
  keysLC.some(k => k.includes('monogram')) ||
  keysLC.some(k => k.includes('inicial')) ||
  keysLC.some(k => k.includes('personaliz') && anyText(props[keys[keysLC.indexOf(k)]])); // data real

// ✅ SOLO esta variable controla el badge “Personalizado”
const hasPersonalizado = !!hasPZData;


      const div = document.createElement('div');
      div.className = 'celestPdp__cartItem';

      const img  = it.image ? `<img src="${it.image}" alt="${it.product_title}">` : '<div class="celestPdp__imgPh"></div>';
      const opts = (it.options_with_values||[]).map(o=>`${o.name}: ${o.value}`).join(' · ');
      const qty  = it.quantity || 1;

      const propPriceCents   = parseInt(props._cel_price_cents   || props._cel_price   || '', 10);
      const propCompareCents = parseInt(props._cel_compare_cents || props._cel_compare || '', 10);

      let regularCents = 0;
      let finalCents   = 0;

      // base desde properties guardadas
      if (!isNaN(propPriceCents)) {
        const unitPrice   = propPriceCents;
        const unitCompare = (!isNaN(propCompareCents) && propCompareCents > unitPrice)
          ? propCompareCents
          : unitPrice;

        regularCents = unitCompare * qty;
        finalCents   = unitPrice   * qty;
      }

      // descuentos Shopify
      const lineDiscounts = it.line_level_discount_allocations || [];
      let autoDiscCents   = 0;
      let autoDiscTitle   = null;

      lineDiscounts.forEach(d => {
        let a = 0;
        if (typeof d.amount === 'number') a = d.amount;
        else if (typeof d.amount === 'string') a = Math.round(parseFloat(d.amount.replace(',', '.')) || 0);
        autoDiscCents += a;
        if (!autoDiscTitle && d.discount_application && d.discount_application.title) {
          autoDiscTitle = d.discount_application.title;
        }
      });

      if (typeof it.final_line_price === 'number') finalCents = it.final_line_price;
      else if (!finalCents) finalCents = it.line_price || 0;

      if (!regularCents) {
        if (typeof it.original_line_price === 'number' && it.original_line_price > 0) regularCents = it.original_line_price;
        else if (autoDiscCents > 0) regularCents = finalCents + autoDiscCents;
        else regularCents = finalCents;
      } else if (autoDiscCents > 0 && regularCents < finalCents + autoDiscCents) {
        regularCents = finalCents + autoDiscCents;
      }

      if (shouldApplyGlobalPerLine) {
        const base = regularCents ||
          (typeof it.original_line_price === 'number' && it.original_line_price > 0
            ? it.original_line_price
            : (it.line_price || it.final_line_price || 0));

        if (base > 0) {
          const discounted = Math.round(base * (100 - globalDiscPct) / 100);
          if (discounted < base) {
            regularCents  = base;
            finalCents    = discounted;
            autoDiscCents = base - discounted;
            if (!autoDiscTitle && globalDiscTitle) autoDiscTitle = globalDiscTitle;
          }
        }
      }

      const hasAutoDiscount  = autoDiscCents > 0;
      const hasPriceDiscount = regularCents > finalCents && regularCents > 0;

      let priceHtml = '';
      if (hasPriceDiscount) {
        const diff = regularCents - finalCents;
        const pct  = regularCents > 0 ? Math.round(diff * 100 / regularCents) : 0;

        const isFreeByDiscount = finalCents <= 0 || pct >= 100;
        const pctLabel = isFreeByDiscount ? 'Gratis' : `${pct}% OFF`;

        const tagClass = isFreeByDiscount ? 'celestCartTag--gift' : 'celestCartTag--discount';
        const tagText  = isFreeByDiscount ? 'GRATIS' : pctLabel;

        priceHtml = `
          <span class="celestCartPrice celestCartPrice--old">${fmtCOP0(regularCents)}</span>
          <span class="celestCartPrice celestCartPrice--new">${fmtCOP0(Math.max(0, finalCents))}</span>
          <span class="celestCartTag ${tagClass}">${tagText}</span>
        `;
      } else {
        priceHtml = `
          <span class="celestCartPrice celestCartPrice--new">${fmtCOP0(finalCents || regularCents || 0)}</span>
        `;
        if (isGiftFlag) {
          priceHtml += `<span class="celestCartTag celestCartTag--gift">GRATIS</span>`;
        }
      }

      let discountInfoHtml = '';
      if (hasAutoDiscount && autoDiscTitle) {
        discountInfoHtml = `
          <div class="celestCart__discountInfo">
            <span class="celestCart__discountIcon" aria-hidden="true">🏷️</span>
            <span class="celestCart__discountText">Descuento aplicado · ${autoDiscTitle}</span>
          </div>
        `;
      }

      const titleBadges = [];
      if (isPO)             titleBadges.push('<span class="celestBadge">Pre-orden</span>');
      if (hasPersonalizado) titleBadges.push('<span class="celestBadge">Personalizado</span>');

      let titleHtml = it.product_title || '';
      if (titleBadges.length) titleHtml += ` <span class="celestCart__titleDash">-</span> ${titleBadges.join(' ')}`;

      let pzHtml = '';
if (hasPersonalizado) {
  const parts = [];

  // Preferir keys “_pz_*” (las más confiables)
  const letters = props['_pz_letters'] || props['Letras'] || props['Iniciales'] || props['Monograma'];
  const colorPz = props['_pz_color']   || props['Color'];
  const puntos  = props['Puntos'];

  if (anyText(letters)) parts.push(`Letras: ${letters}`);
  if (anyText(colorPz)) parts.push(`Color: ${colorPz}`);
  if (puntos !== undefined && puntos !== null && String(puntos).trim() !== '') parts.push(`Puntos: ${puntos}`);

  // Si tu modal guarda un resumen listo, úsalo
  const summary = props['_pz_summary'];
  const priceText = anyText(props['_pz_price_text']) ? ` · ${props['_pz_price_text']}` : '';

  const label = 'Personalización';

  if (anyText(summary)) {
    pzHtml = `<div class="celestPdp__opts" style="margin-top:4px;">${label}: ${summary}${priceText}</div>`;
  } else if (parts.length || priceText) {
    pzHtml = `<div class="celestPdp__opts" style="margin-top:4px;">${label}: ${parts.join(' · ')}${priceText}</div>`;
  }
}


      div.innerHTML = `
        <div class="celestPdp__itemLeft">${img}</div>

        <div class="celestPdp__itemRight">
          <div class="t1 celestPdp__title">${titleHtml}</div>
          <div class="t2 celestPdp__opts">${opts || ''}</div>
          ${pzHtml}
          <div class="t3 celestPdp__price">${priceHtml}</div>
          ${discountInfoHtml}

          <div class="celestPdp__qtyAndDelete">
            <div class="celestPdp__qtyMini"
                 data-key="${it.key}"
                 data-line="${idx+1}"
                 data-vid="${it.variant_id}">
              <button type="button" class="qMinus" aria-label="Disminuir">−</button>
              <span class="qVal">${it.quantity}</span>
              <button type="button" class="qPlus" aria-label="Aumentar">+</button>
            </div>

            <button class="celestPdp__deleteItem" data-key="${it.key}" aria-label="Eliminar producto">
              <svg viewBox="0 0 24 24" width="22" height="22">
                <path d="M3 6h18M10 6V4h4v2m-7 3h10l-1 11H7L6 9z"
                      stroke="currentColor" stroke-width="1.8" fill="none"
                      stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      `;
      cartItems.appendChild(div);
    });

    // reinsert upsell al final
    if (upsellSlot && cartItems){
      cartItems.appendChild(upsellSlot);
      upsellSlot.hidden = false;
    }

    const isEmpty = !items || items.length === 0;
    cartItems.classList.toggle('is-empty', !!isEmpty);
    // ✅ FIX: empty state centrado real (no depender de minHeight del layout)
if (isEmpty){
  cartItems.style.display = 'flex';
  cartItems.style.flexDirection = 'column';
  cartItems.style.justifyContent = 'center';
  cartItems.style.alignItems = 'center';
  cartItems.style.minHeight = '0';
  cartItems.style.maxHeight = 'none';
} else {
  cartItems.style.display = '';
  cartItems.style.flexDirection = '';
  cartItems.style.justifyContent = '';
  cartItems.style.alignItems = '';
}


    const emptyTextEl2 = ensureEmptyText();
    if (emptyTextEl2) emptyTextEl2.style.display = isEmpty ? '' : 'none';

    // ocultar descuento si vacío
    if (discUI && discUI.wrap) discUI.wrap.style.display = isEmpty ? 'none' : '';

    // ocultar info cuando vacío
    const shipBoxEl2  = $('.celestPdp__shipBox', rootModal);
    const subtotalRow = $('.celestPdp__cartSubtotal', rootModal);
    const actionsRow  = $('.celestPdp__cartActions', rootModal);
    if (shipBoxEl2)  shipBoxEl2.style.display  = isEmpty ? 'none' : '';
    if (subtotalRow) subtotalRow.style.display = isEmpty ? 'none' : '';
    if (actionsRow)  actionsRow.style.display  = isEmpty ? 'none' : '';

    // subtotal (antes y después)
    if (subtotalEl) {
      const totalCents = (typeof cart.total_price === 'number' && cart.total_price >= 0)
        ? cart.total_price
        : (cart.items_subtotal_price || 0);

      const beforeCents = (typeof cart.items_subtotal_price === 'number')
        ? cart.items_subtotal_price
        : totalCents;

      if (beforeCents > totalCents) {
        subtotalEl.innerHTML = `
          <span class="celestPdp__subtotalOld">${fmtCOP0(beforeCents)}</span>
          <span class="celestPdp__subtotalNew">${fmtCOP0(totalCents)}</span>
        `.trim();
      } else {
        subtotalEl.textContent = fmtCOP0(totalCents);
      }
    }

    // envío gratis usa total con descuentos
    if (!hasOnlyPO) {
      const subtotalForFreeShipping =
        (typeof cart.total_price === 'number' && cart.total_price >= 0)
          ? cart.total_price
          : (cart.items_subtotal_price || 0);

      updateShipping(subtotalForFreeShipping, cart);
    } else {
      if (shipTextEl) shipTextEl.textContent = '';
      if (shipBarEl)  shipBarEl.style.width='0%';
      if (etaTextEl)  etaTextEl.innerHTML = '';
    }

    // cupón UI
    renderDiscountUIFromCart(cart);

    // binds + sync
    bindQtyMini(cartItems);
    bindDeleteMini(cartItems);
    syncThemeCount(cart);
  }
  function bindViewportRecalc(){
  if (window.__celestMiniCartViewportBound) return;
  window.__celestMiniCartViewportBound = true;

  const recalc = ()=> {
    if (!document.body.classList.contains('celestCart-open')) return;
    setMiniCartTopUnderHeader();
  };

  window.addEventListener('resize', recalc, { passive:true });

  if (window.visualViewport){
    visualViewport.addEventListener('resize', recalc, { passive:true });
    visualViewport.addEventListener('scroll', recalc, { passive:true }); // iOS mueve el viewport al hacer scroll
  }

  // Si tu header cambia de tamaño al hacer scroll (sticky / shrink)
  window.addEventListener('scroll', recalc, { passive:true });
}


  /* -------------------------
     Public API
  ------------------------- */
  api.open = async function(){
    try{
      const cart = await fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(r=>r.json());
      renderMiniCart(cart);
    }catch(_){}
    openCart();
  };
  api.close = closeCartFn;
  api.render = renderMiniCart;

  /* -------------------------
     Bridge event (tu bloque)
  ------------------------- */
  function bindBridge(){
    if (document.__celestMiniCartBridgeBound) return;

    document.addEventListener('celest:openMiniCart', async (ev) => {
      try {
        const incoming = ev?.detail?.cart;
        const cart = incoming || await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
        renderMiniCart(cart);
        openCart();
      } catch (_e) {
        openCart();
      }
    });

    document.__celestMiniCartBridgeBound = true;
  }

  /* -------------------------
     Reopen after /discount/clear
  ------------------------- */
  function bindAfterClearDiscount(){
    try{
      if (sessionStorage.getItem('celest_after_clear_discount_open_cart') === '1'){
        sessionStorage.removeItem('celest_after_clear_discount_open_cart');
        fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
          .then(r=>r.json())
          .then(cart => { renderMiniCart(cart); openCart(); })
          .catch(_=>{});
      }
    }catch(_){}
  }

  /* -------------------------
     Hook: header cart icon -> open Celest mini cart (bloquea tema)
  ------------------------- */
  function bindHeaderHook(){
    // Captura en fase "true" para ganar al tema
    document.addEventListener('click', async (e)=>{
      const cartIcon = e.target.closest(
        '[data-cart-toggle], .header__icon--cart, a[href="/cart"], button[name="cart"], .js-open-cart, .Header__Icon--cart, .site-header__cart, .header__icon--bag'
      );
      if(!cartIcon) return;

      // si es link /cart normal, bloquea navegación
      e.preventDefault();
      e.stopPropagation();

      // overlay breve (tu lógica)
      if(CFG.SHOW_OVERLAY && CFG.LOADER_MODE !== 'off'){
        const overlay = ensureOverlay();
        const inner = overlay.querySelector('.celestLoaderOverlay__inner');
        inner.innerHTML = '';

        let node;
        const paths = resolveMorphPaths();
        switch(CFG.LOADER_MODE){
          case 'spin': node = buildSpin(CFG.ICONS.cart, CFG.OVER_SIZE); break;
          case 'morph': node = buildMorph(CFG.OVER_SIZE, paths); break;
          case 'both': node = buildBoth(CFG.OVER_SIZE, paths); break;
          case 'sketch': node = buildSketch(CFG.OVER_SIZE, CFG.SKETCH_IMG || CFG.ICONS.cart || CFG.ICONS.add); break;
          default: node = buildSpin(CFG.ICONS.cart, CFG.OVER_SIZE);
        }
        inner.appendChild(node);
        overlay.style.background = `rgba(0,0,0, ${Math.max(0, Math.min(100, CFG.OVER_ALPHA))/100})`;
        overlay.hidden = false;
        setTimeout(()=>{ overlay.hidden = true; inner.innerHTML=''; }, 800);
      }

      await api.open();
    }, true);
  }

  /* -------------------------
     Hook: close events
  ------------------------- */
  function bindCloseEvents(){
    closeCartBtn?.addEventListener('click', closeCartFn);
    continueBtn?.addEventListener('click', (e)=>{ e.preventDefault(); closeCartFn(); });
    rootModal?.addEventListener('click', (e)=>{
      if(e.target===rootModal && mm.matches) closeCartFn();
    });

    document.addEventListener('keydown', (e)=>{
      if(e.key === 'Escape' && document.body.classList.contains('celestCart-open')){
        closeCartFn();
      }
    });
  }

  /* -------------------------
     Add-to-cart GLOBAL (AJAX)
     - Intercepta cualquier form /cart/add
     - Añade properties de precios base si puede inferirlos desde JSON cercano (opcional)
  ------------------------- */
  function safeJSON(elm){
    try{ return elm ? JSON.parse(elm.textContent||'{}') : null; }catch(_){ return null; }
  }

  function findNearbyProductJSON(form){
    // intenta encontrar JSON cercano que contenga variants
    const scope = form.closest('product-form') || form.closest('.product') || form.parentElement || document;
    const scripts = $$('script[type="application/json"], .product__json', scope);
    const obj = scripts.map(s=>safeJSON(s)).find(o=>o && Array.isArray(o.variants));
    return obj || null;
  }

  function enhanceFormWithPriceProps(fd, form){
    try{
      const id = fd.get('id');
      if(!id) return;

      // si ya vienen, no tocar
      if(fd.get('properties[_cel_price_cents]') || fd.get('properties[_cel_compare_cents]')) return;

      const p = findNearbyProductJSON(form);
      if(!p || !Array.isArray(p.variants)) return;

      const v = p.variants.find(v=>String(v.id)===String(id));
      if(!v) return;

      if(typeof v.price === 'number'){
        fd.set('properties[_cel_price_cents]', String(v.price));
      }
      if(typeof v.compare_at_price === 'number' && v.compare_at_price > v.price){
        fd.set('properties[_cel_compare_cents]', String(v.compare_at_price));
      }
    }catch(_){}
  }
function isCelestMobilePdpForm(form){
  return !!form.closest('#celest-mobile-pdp');
}

// Detecta si el form realmente tiene una variante “seleccionada” (no default)
function formHasSelectedVariant(form, fd){
  // 1) si hay un input id con valor
  const id = (fd && fd.get('id')) || (form.querySelector('input[name="id"]')?.value);
  if (!id || String(id).trim() === '') return false;

  // 2) si en tu PDP guardas la selección en data-selected-variant o algo parecido
  // (esto ayuda cuando el input id existe pero el usuario no escogió talla y queda en "primera")
  const root = form.closest('#celest-mobile-pdp');
  const ds = root?.dataset || {};
  const selected = ds.selectedVariant || ds.variantId || ds.selectedVariantId; // por si ya tienes alguno
  if (selected && String(selected).trim() !== '') return true;

  // 3) heurística: si hay botón/selector de talla marcado como active/selected
  const sizeSelected =
    !!root?.querySelector('.is-active[data-variant-id], .is-selected[data-variant-id], [aria-pressed="true"][data-variant-id], input[type="radio"][name*="size"]:checked');

  return sizeSelected;
}

  function bindGlobalAddToCart(){
    document.addEventListener('submit', async (e)=>{
      const form = e.target;
      if(!(form instanceof HTMLFormElement)) return;
      const action = (form.getAttribute('action')||'').toLowerCase();
      if(!action.includes('/cart/add')) return;

      // permitir opt-out
      if(form.hasAttribute('data-celest-no-ajax')) return;

      // evitar duplicar si ya interceptado por otro script tuyo
      if(form.__celestAjaxBound) return;
      form.__celestAjaxBound = true;

      // Nota: aquí NO hacemos preventDefault todavía.
    }, true);

    // Capturamos submit real en bubbling (más confiable)
    document.addEventListener('submit', async (e)=>{
      const form = e.target;
      if(!(form instanceof HTMLFormElement)) return;
      const action = (form.getAttribute('action')||'').toLowerCase();
      if(!action.includes('/cart/add')) return;
      if(form.hasAttribute('data-celest-no-ajax')) return;

      // si el submit viene de botones de pago dinámico, no interceptar
      const submitter = e.submitter;
      if(submitter && (
        submitter.name === 'checkout' ||
        submitter.classList?.contains('shopify-payment-button__button') ||
        submitter.getAttribute('data-shopify') === 'payment-button'
      )) return;

      const fd = new FormData(form);

// ✅ FIX: en tu PDP móvil, si NO hay talla/variante válida, NO interceptar.
// Deja que tu JS del PDP haga su vibración/bloqueo normal.
if (isCelestMobilePdpForm(form) && !formHasSelectedVariant(form, fd)) {
  return; // NO preventDefault, NO AJAX global
}

e.preventDefault();

if (!fd.get('quantity')) fd.set('quantity', '1');


      // Enriquecer con prices base si es posible
      enhanceFormWithPriceProps(fd, form);

      // Loader dentro del botón principal si existe
      let addBtn = submitter || form.querySelector('button[type="submit"], button[name="add"], [data-add-to-cart], .product-form__submit');
      if(addBtn && CFG.SHOW_BTNS && CFG.LOADER_MODE !== 'off'){
        putLoaderInsideButton(addBtn, CFG.ICONS.add);
      }

      try{
        await fetch('/cart/add.js', { method:'POST', body: fd, headers: { 'Accept':'application/json' } });
        const cart = await fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(r=>r.json());
        if(addBtn) clearButtonLoader(addBtn);
        renderMiniCart(cart);
        openCart();
      }catch(err){
        console.error('Add to cart error', err);
        if(addBtn) clearButtonLoader(addBtn);
      }
    }, false);
  }

  /* -------------------------
     Checkout loader (igual que tu bloque)
  ------------------------- */
  function bindCheckoutLoader(){
    if(checkoutBtn && CFG.SHOW_BTNS && CFG.LOADER_MODE !== 'off'){
      checkoutBtn.addEventListener('click', function(){
        putLoaderInsideButton(checkoutBtn, CFG.ICONS.checkout);
        setTimeout(()=>clearButtonLoader(checkoutBtn), 5000);
      });
    }
  }

  /* -------------------------
     Init
  ------------------------- */
  onReady(async ()=>{
    cacheNodes();
    ensureOverlay();
    bindBridge();
    bindAfterClearDiscount();

     bindViewportRecalc();

    bindHeaderHook();
    bindCloseEvents();
    bindGlobalAddToCart();
    bindCheckoutLoader();

    // primer render “silencioso” para tener count y estados listos
    try{
      const cart = await fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(r=>r.json());
      renderMiniCart(cart);
    }catch(_){}
  });

})();
